// Cash movements are read from the journal and reconciled to the trial balance.
// Revenue, expenses and open items never stand in for cash receipts/payments.
const advisorCashBasisApi = (() => {
  const cents = (value: unknown) => Math.round(Number(value) * 100)
  const build = ({ state, year, readTrial }: { state: any; year: number; readTrial: (month: number) => any[] }) => {
    // The Norwegian chart's cash/bank group is the only supported mapping here.
    // Other jurisdictions stay unavailable until their mapping is explicit.
    if (state?.settings?.country !== 'NO' || !Array.isArray(state.accountingEvents) || !Number.isInteger(year)) return null
    const cash = (account: unknown) => /^19\d{2}(?::[A-Za-z0-9_-]+)?$/.test(String(account))
    const flows = Array.from({ length: 12 }, () => ({ inn: 0, ut: 0 }))
    for (const event of state.accountingEvents) {
      if (event.source_type === 'openingBalance') continue
      const date = String(event.accounting_date || '')
      if (!date.startsWith(`${year}-`)) continue
      const month = Number(date.slice(5, 7)) - 1
      if (month < 0 || month > 11 || !Array.isArray(event.posting_lines)) return null
      // Net each event across cash accounts: an internal bank transfer is not income/outflow.
      const movement = event.posting_lines.filter((line: any) => cash(line.account)).reduce((sum: number, line: any) => sum + cents(line.signed_amount), 0)
      if (!Number.isFinite(movement)) return null
      if (movement > 0) flows[month].inn += movement
      else flows[month].ut -= movement
    }
    let opening: number | null = null, previous: number | null = null
    const months = []
    for (let month = 0; month < 12; month++) {
      const accounts = readTrial(month).flatMap(group => group.accounts || []).filter(account => cash(account.nr))
      const start = accounts.reduce((sum, account) => sum + cents(account.inn), 0)
      const end = accounts.reduce((sum, account) => sum + cents(account.ut), 0)
      if (![start, end].every(Number.isFinite) || (previous !== null && previous !== start)) return null
      if (end - start !== flows[month].inn - flows[month].ut) return null
      if (opening === null) opening = start
      months.push({ balance: end / 100, inn: flows[month].inn / 100, ut: flows[month].ut / 100 })
      previous = end
    }
    return { source: 'reconciled-journal-cash', year, opening: (opening || 0) / 100, months }
  }
  return { build }
})()
window.PlummeAdvisorCashBasis = advisorCashBasisApi
